<script setup lang="ts">
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import type { Elemental } from '~~/src/types/elemental'

const { elemental, route } = defineProps<{
  elemental: Elemental
  route: string
}>()

const { push } = useRouter()
const open = () => {
  push(`/${route}/${elemental.url}?view_type=feed`)
}
defineOptions({
  name: 'OpenElementalFeedOption',
})
</script>

<template>
  <DropdownMenuItem @click="open">
    <IconFeedView />
    Open Feed View
  </DropdownMenuItem>
</template>
